<template>
  <d-modal
    size="lg"
    class="big-popup"
    @close="closePopup">
    <d-modal-header>
      <d-modal-title>
        {{ popupTitle }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <orders
        :inPopup="true"
        :popupShowAllUI="showAllUI"
        :forcedCustomerID="customerID"
        :customerPopupContent="popupContent" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import Orders from './../../views/Orders';

export default {
  name: 'orders-popup',
  props: [
    'popupContent',
    'showAllUI',
    'customerID'
  ],
  components: {
    'orders': Orders
  },
  computed: {
    popupTitle () {
      if (this.popupContent === 'orders') {
        return this.$t('customerOrdersPopup.orders');
      }

      if (this.popupContent === 'offers') {
        return this.$t('customerOrdersPopup.offers');
      }

      return '';
    }
  },
  methods: {
    closePopup () {
      this.$bus.$emit('customer-orders-popup-close');
    }
  }
}
</script>
